import { setCatAttribute } from '@/services/api/cats'
import type { CatDescription } from '@/types/models'

/**
 * Writes what the description engine read as *suggestions*, tagged with their
 * provenance. A person editing any of them replaces the value outright and the
 * source becomes human — the machine never wins an argument with the owner.
 * (§21)
 */
export async function applyDescription(
  userCatId: string,
  description: CatDescription | null,
): Promise<void> {
  if (!description) return

  const writes: Array<Promise<unknown>> = []
  const single = (type: 'breed_or_type' | 'coat' | 'eye_color', value: string | null) => {
    if (!value) return
    writes.push(
      setCatAttribute({
        userCatId,
        type,
        value,
        source: 'ai',
        confidence: description.confidence,
      }),
    )
  }

  single('breed_or_type', description.breed_or_type)
  single('coat', description.coat)
  single('eye_color', description.eye_color)

  for (const trait of description.traits) {
    writes.push(
      setCatAttribute({
        userCatId,
        type: 'trait',
        value: trait,
        source: 'ai',
        confidence: description.confidence,
      }),
    )
  }

  // A failed suggestion is not worth failing the capture over.
  await Promise.allSettled(writes)
}

export const ATTRIBUTE_LABELS: Record<string, string> = {
  breed_or_type: 'Tipo',
  coat: 'Pelaje',
  eye_color: 'Ojos',
  trait: 'Rasgo',
  collar: 'Collar',
  note: 'Nota',
}
